export default __webpack_public_path__ + "static/hackathon-grid-7-255202f22ce9b302bcf8ef9ac7abb637.png";